import { ValueOf } from "../../Common/typeUtils";
import { techRegistrationFlows } from "../../constants/constants";
import { APIResponse } from "../common/response";
import { rooFetch } from "../common/rooFetch";
import { License } from "../vet";

// Parameters accepted by the endpoint
type Request = {
  userId: number;
  techId: number;
} & Partial<{
  firstName: string;
  lastName: string;
  zipcode: string;
  travelDistance: number;
  phoneNumber: string;
  licenses: License[];
  deletedLicenses: undefined; // not supported since this endpoint is idempotent
  school: string;
  yearsOfPractice: number;
  isCertified: boolean;
  isRegistered: boolean;
  isLicensed: boolean;
  isVTS: boolean;
  userType: undefined;
}>;

type Response<RequestBody extends Request> = APIResponse<
  RequestBody & {
    metroAreaId?: number;
    stateId?: number;
    stateName?: string;
    techRegistrationFlow?: ValueOf<typeof techRegistrationFlows>;
  }
>;

export const patchTech = async <NarrowRequest extends Request>(
  request: NarrowRequest
): Promise<Response<NarrowRequest>> => {
  const response = await rooFetch(`${window.RooConfig.API_URL}api/tech/tech`, {
    method: "PATCH",
    body: JSON.stringify(request),
  });

  if (response.status !== 200) {
    throw new Error("Api failed");
  }

  const data = await response.json();
  return data;
};
